<template lang="pug">
div
  v-list-item
    v-list-item-content
      v-list-item-title.title
        | ControleTotall
  v-divider
  v-list
    template(v-for='(item, index) in items')
      v-list-item(v-if='!item.subLinks' :key='item.title' :to='item.to' color='#000000')
        v-list-item-icon
          v-icon {{item.icon}}
        v-list-item-title {{item.title}}
      v-list-group(v-else :prepend-icon='item.icon' :key='item.title' no-action='no-action' color='#000000')
        template(v-slot:activator='')
          v-list-item-content
            v-list-item-title {{item.title}}
        v-list-item(v-for='(sublink, i) in item.subLinks' :key='i' :to='sublink.to' color='#000000')
          v-list-item-title(v-text='sublink.title')
          v-list-item-action
            v-icon(v-text='sublink.icon')
</template>

<script>
export default {
  data () {
    return {
      items: [
        { title: 'Home', icon: 'mdi-home', to: '/' },
        {
          title: 'Eventos',
          icon: 'mdi-calendar',
          to: '/events'
        },
        {
          title: 'Usuários',
          icon: 'mdi-account-multiple',
          to: '/users'
        },
        {
          title: 'Pessoas',
          icon: 'mdi-account-star-outline',
          to: '/people'
        }
      ]
    }
  }
}
</script>
